import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { isMobileApp, openAIConciergeinBrowser } from '../utils/platformDetection';
import { isPartnerClientBrand, useClientBranding } from '../contexts/ClientBrandingContext';
import AIConcierge from '../pages/AIConcierge';

/**
 * Wrapper component for AI Concierge that redirects to external browser in mobile apps
 * This complies with Apple's In-App Purchase guidelines
 */
const AIConciergeRedirect = () => {
  const navigate = useNavigate();
  const { branding } = useClientBranding();
  const partnerClientBrand = isPartnerClientBrand(branding);

  useEffect(() => {
    if (partnerClientBrand) {
      navigate('/trips', { replace: true });
      return;
    }
    // If running in mobile app, redirect to external web browser
    if (isMobileApp()) {
      console.log('[AIConciergeRedirect] Mobile app detected - opening in external browser');
      openAIConciergeinBrowser();
      
      // Navigate back to previous page after a short delay
      setTimeout(() => {
        navigate(-1);
      }, 500);
    }
  }, [navigate, partnerClientBrand]);

  if (partnerClientBrand) {
    return null;
  }

  // If mobile app, show loading while redirecting
  if (isMobileApp()) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          Opening AI Concierge in browser...
        </Typography>
      </Box>
    );
  }

  // If web browser, render normally
  return <AIConcierge />;
};

export default AIConciergeRedirect;

